import { render, staticRenderFns } from "./RulesStatusSelector.vue?vue&type=template&id=a1070648"
import script from "./RulesStatusSelector.vue?vue&type=script&lang=js"
export * from "./RulesStatusSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports